import React, { Component } from 'react';


class About extends Component {
    render() {
        return (
            <div className="condiv">
            <h1 className="subtopic">About Me</h1>
            <br />
            <h4>Hey there..</h4>
            {/* <br /> */}
            <h1>I'm Dinesh Giri </h1>
            <h3>Frontend <u>Developer</u> </h3>
            <br></br>
            

            <p>Energetic and passionate college student working towards a B.Tech in Electronics and Communication Engineering at the Dr APJ Abdul Kalam Technical University (UP).
                 A motivated individual with knowledge of languages and development tools,seeking to find an opportunity to work in a challenging and progressive working environment that will encourage me to improve as well as be motivated 
                by the company to do my best for the sake of helping colleagues</p>
            
            </div>
            )
        }
    }
    
export default About
    